import React, { useEffect, useRef, useState } from 'react';

const AnimatedTextContainer = (props) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(ref.current); // only trigger once
        }
      },
      { threshold: 0.35 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  const style = {
    opacity: visible ? 1 : 0,
    transition: 'opacity 1s ease-in',
  };

  return (
    <div ref={ref} style={style}>
      {props.children}
    </div>
  );
};

export default AnimatedTextContainer;
